module.exports = __webpack_public_path__ + "static/media/0030_IMG_LES_ENSEIGNES_LE_PRIMEUR_LETTRE_A_LETTRE.ac58b633.webp";